import * as React from 'react';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { AutocompleteListDataService } from 'src/core/ui/autocomplete/autocomplete.data';
import { ContractsAgeBandView } from './contract-ageband.view';
import { DataLocalService } from 'src/core/services/data-local.service';

interface ContractsAgeBandControllerProps extends ComponentViewProps<AgeBandItem[]> {
	mode: ControlMode;
	updateAgeBands?: (items: AgeBandItem[], oldType?: string, newType?: string) => void;
}

@observer
export class ContractsAgeBandController extends React.Component<ContractsAgeBandControllerProps, any> {
	protected ageTypeDataService: AutocompleteListDataService;

	@observable
	dataSet: DataLocalService<AgeBandItem>;

	constructor(props) {
		super(props);
		this.ageTypeDataService = AutocompleteListDataService.make();
	}

	@autobind
	private ageTypesQuery(q?: string) {
		return new Promise<QueryResult<AutocompleteSummary>>((resolve, reject) => {
			this.ageTypeDataService.addFilter('concept', 'eq', 'contract');
			this.ageTypeDataService.addFilter('key', 'eq', 'age-type');
			this.ageTypeDataService.addSorting('value', 'asc', true);
			this.ageTypeDataService.searchKeywords = q;
			this.ageTypeDataService.pageSize = 100;

			return this.ageTypeDataService
				.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.ageTypeDataService.totalPages
					});
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	componentDidMount() {
		this.dataSet = this.props.model != null ? new DataLocalService(this.props.model) : null;
	}

	render() {
		if (this.dataSet == null) {
			return <div>No age band information</div>
		}

		const columns = [];
		return (
			<ContractsAgeBandView
				mode={this.props.mode}
				model={this.dataSet}
				columns={columns}
				setBusy={this.props.setBusy}
				ageTypesQuery={{ query: this.ageTypesQuery, dataSet: this.ageTypeDataService }}
				updateAgeBands={this.props.updateAgeBands}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-ageband.controller.tsx